export default __webpack_public_path__ + "static/media/rest_api.c21b0d46.svg";